import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":academicYearId",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-gradingPeriods-academicYear" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [],
});
